const parkingLots = {
  type: 'FeatureCollection',
  features: [
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.21515, 49.9178, 0],
            [-97.21515, 49.91716, 0],
            [-97.21389, 49.91716, 0],
            [-97.21389, 49.9178, 0],
            [-97.21515, 49.9178, 0],
          ],
        ],
      },
      properties: {
        name: 'W1',
        styleUrl: '#poly-639E6C-1000-255-nodesc',
        styleHash: '-1c067536',
        styleMapHash: {
          normal: '#poly-639E6C-1000-255-nodesc-normal',
          highlight: '#poly-639E6C-1000-255-nodesc-highlight',
        },
        stroke: '#639e6c',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#639e6c',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.21515, 49.91862, 0],
            [-97.21515, 49.91791, 0],
            [-97.21389, 49.91791, 0],
            [-97.21389, 49.91862, 0],
            [-97.21515, 49.91862, 0],
          ],
        ],
      },
      properties: {
        name: 'W2',
        styleUrl: '#poly-ED1847-1000-255-nodesc',
        styleHash: '16f132b7',
        styleMapHash: {
          normal: '#poly-ED1847-1000-255-nodesc-normal',
          highlight: '#poly-ED1847-1000-255-nodesc-highlight',
        },
        stroke: '#ed1847',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#ed1847',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.21515, 49.91955, 0],
            [-97.21515, 49.91874, 0],
            [-97.21389, 49.91874, 0],
            [-97.21389, 49.91955, 0],
            [-97.21515, 49.91955, 0],
          ],
        ],
      },
      properties: {
        name: 'W3',
        styleUrl: '#poly-ED1847-1000-255-nodesc',
        styleHash: '16f132b7',
        styleMapHash: {
          normal: '#poly-ED1847-1000-255-nodesc-normal',
          highlight: '#poly-ED1847-1000-255-nodesc-highlight',
        },
        stroke: '#ed1847',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#ed1847',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.21515, 49.92043, 0],
            [-97.21515, 49.9198, 0],
            [-97.21389, 49.9198, 0],
            [-97.21389, 49.92043, 0],
            [-97.21515, 49.92043, 0],
          ],
        ],
      },
      properties: {
        name: 'W4',
        styleUrl: '#poly-ED1847-1000-255-nodesc',
        styleHash: '16f132b7',
        styleMapHash: {
          normal: '#poly-ED1847-1000-255-nodesc-normal',
          highlight: '#poly-ED1847-1000-255-nodesc-highlight',
        },
        stroke: '#ed1847',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#ed1847',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.21317, 49.91937, 0],
            [-97.21317, 49.91902, 0],
            [-97.21273, 49.91902, 0],
            [-97.21273, 49.91937, 0],
            [-97.21317, 49.91937, 0],
          ],
        ],
      },
      properties: {
        name: 'C1',
        styleUrl: '#poly-00A3B4-1000-255-nodesc',
        styleHash: '64f725bc',
        styleMapHash: {
          normal: '#poly-00A3B4-1000-255-nodesc-normal',
          highlight: '#poly-00A3B4-1000-255-nodesc-highlight',
        },
        stroke: '#00a3b4',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#00a3b4',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.21252, 49.91963, 0],
            [-97.21252, 49.91945, 0],
            [-97.21148, 49.91945, 0],
            [-97.21148, 49.91963, 0],
            [-97.21252, 49.91963, 0],
          ],
        ],
      },
      properties: {
        name: 'C2',
        styleUrl: '#poly-00A3B4-1000-255-nodesc',
        styleHash: '64f725bc',
        styleMapHash: {
          normal: '#poly-00A3B4-1000-255-nodesc-normal',
          highlight: '#poly-00A3B4-1000-255-nodesc-highlight',
        },
        stroke: '#00a3b4',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#00a3b4',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.21126, 49.91963, 0],
            [-97.21126, 49.91945, 0],
            [-97.2108, 49.91945, 0],
            [-97.2108, 49.91963, 0],
            [-97.21126, 49.91963, 0],
          ],
        ],
      },
      properties: {
        name: 'C3',
        styleUrl: '#poly-00A3B4-1000-255-nodesc',
        styleHash: '64f725bc',
        styleMapHash: {
          normal: '#poly-00A3B4-1000-255-nodesc-normal',
          highlight: '#poly-00A3B4-1000-255-nodesc-highlight',
        },
        stroke: '#00a3b4',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#00a3b4',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.21094, 49.91896, 0],
            [-97.21094, 49.91878, 0],
            [-97.21047, 49.91878, 0],
            [-97.21047, 49.91896, 0],
            [-97.21094, 49.91896, 0],
          ],
        ],
      },
      properties: {
        name: 'C4',
        styleUrl: '#poly-00A3B4-1000-255-nodesc',
        styleHash: '64f725bc',
        styleMapHash: {
          normal: '#poly-00A3B4-1000-255-nodesc-normal',
          highlight: '#poly-00A3B4-1000-255-nodesc-highlight',
        },
        stroke: '#00a3b4',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#00a3b4',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.20896, 49.91947, 0],
            [-97.20896, 49.91905, 0],
            [-97.20795, 49.91905, 0],
            [-97.20795, 49.91947, 0],
            [-97.20896, 49.91947, 0],
          ],
        ],
      },
      properties: {
        name: 'C5',
        styleUrl: '#poly-00A3B4-1000-255-nodesc',
        styleHash: '64f725bc',
        styleMapHash: {
          normal: '#poly-00A3B4-1000-255-nodesc-normal',
          highlight: '#poly-00A3B4-1000-255-nodesc-highlight',
        },
        stroke: '#00a3b4',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#00a3b4',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.20812, 49.91875, 0],
            [-97.20812, 49.91837, 0],
            [-97.20751, 49.91837, 0],
            [-97.20751, 49.91875, 0],
            [-97.20812, 49.91875, 0],
          ],
        ],
      },
      properties: {
        name: 'C6',
        styleUrl: '#poly-00A3B4-1000-255-nodesc',
        styleHash: '64f725bc',
        styleMapHash: {
          normal: '#poly-00A3B4-1000-255-nodesc-normal',
          highlight: '#poly-00A3B4-1000-255-nodesc-highlight',
        },
        stroke: '#00a3b4',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#00a3b4',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.21142, 49.91728, 0],
            [-97.21142, 49.91666, 0],
            [-97.21009, 49.91666, 0],
            [-97.21009, 49.91728, 0],
            [-97.21142, 49.91728, 0],
          ],
        ],
      },
      properties: {
        name: 'S1',
        styleUrl: '#poly-F26130-1000-255-nodesc',
        styleHash: '-d5e06c4',
        styleMapHash: {
          normal: '#poly-F26130-1000-255-nodesc-normal',
          highlight: '#poly-F26130-1000-255-nodesc-highlight',
        },
        stroke: '#f26130',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#f26130',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.20975, 49.91768, 0],
            [-97.20975, 49.91738, 0],
            [-97.20877, 49.91738, 0],
            [-97.20877, 49.91754, 0],
            [-97.20918, 49.91754, 0],
            [-97.20918, 49.91768, 0],
            [-97.20975, 49.91768, 0],
          ],
        ],
      },
      properties: {
        name: 'S2',
        styleUrl: '#poly-F26130-1000-255-nodesc',
        styleHash: '-d5e06c4',
        styleMapHash: {
          normal: '#poly-F26130-1000-255-nodesc-normal',
          highlight: '#poly-F26130-1000-255-nodesc-highlight',
        },
        stroke: '#f26130',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#f26130',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.209958, 49.91728, 0],
            [-97.209958, 49.91666, 0],
            [-97.209773, 49.91666, 0],
            [-97.209773, 49.91728, 0],
            [-97.209958, 49.91728, 0],
          ],
        ],
      },
      properties: {
        name: 'S3',
        styleUrl: '#poly-639E6C-1000-255-nodesc',
        styleHash: '-1c067536',
        styleMapHash: {
          normal: '#poly-639E6C-1000-255-nodesc-normal',
          highlight: '#poly-639E6C-1000-255-nodesc-highlight',
        },
        stroke: '#639e6c',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#639e6c',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.20844, 49.917492, 0],
            [-97.208609, 49.917446, 0],
            [-97.208107, 49.916691, 0],
            [-97.207946, 49.916746, 0],
            [-97.20844, 49.917492, 0],
          ],
        ],
      },
      properties: {
        name: 'S3',
        styleUrl: '#poly-639E6C-1000-255-nodesc',
        styleHash: '-1c067536',
        styleMapHash: {
          normal: '#poly-639E6C-1000-255-nodesc-normal',
          highlight: '#poly-639E6C-1000-255-nodesc-highlight',
        },
        stroke: '#639e6c',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#639e6c',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.2079, 49.91947, 0],
            [-97.2079, 49.91931, 0],
            [-97.20732, 49.91931, 0],
            [-97.20732, 49.9199, 0],
            [-97.2076, 49.9199, 0],
            [-97.2076, 49.91947, 0],
            [-97.2079, 49.91947, 0],
          ],
        ],
      },
      properties: {
        name: 'N1',
        styleUrl: '#poly-639E6C-1000-255-nodesc',
        styleHash: '-1c067536',
        styleMapHash: {
          normal: '#poly-639E6C-1000-255-nodesc-normal',
          highlight: '#poly-639E6C-1000-255-nodesc-highlight',
        },
        stroke: '#639e6c',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#639e6c',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.21061, 49.92084, 0],
            [-97.21061, 49.92031, 0],
            [-97.21002, 49.92031, 0],
            [-97.21002, 49.92051, 0],
            [-97.20928, 49.92051, 0],
            [-97.20928, 49.92084, 0],
            [-97.21061, 49.92084, 0],
          ],
        ],
      },
      properties: {
        name: 'N2',
        styleUrl: '#poly-6680B5-1000-255-nodesc',
        styleHash: '-1562606b',
        styleMapHash: {
          normal: '#poly-6680B5-1000-255-nodesc-normal',
          highlight: '#poly-6680B5-1000-255-nodesc-highlight',
        },
        stroke: '#6680b5',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#6680b5',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.20919, 49.92084, 0],
            [-97.20919, 49.92051, 0],
            [-97.20793, 49.92051, 0],
            [-97.20793, 49.92014, 0],
            [-97.20732, 49.92014, 0],
            [-97.20732, 49.92084, 0],
            [-97.20919, 49.92084, 0],
          ],
        ],
      },
      properties: {
        name: 'N3',
        styleUrl: '#poly-6680B5-1000-255-nodesc',
        styleHash: '-1562606b',
        styleMapHash: {
          normal: '#poly-6680B5-1000-255-nodesc-normal',
          highlight: '#poly-6680B5-1000-255-nodesc-highlight',
        },
        stroke: '#6680b5',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#6680b5',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.20943, 49.9218, 0],
            [-97.20943, 49.92101, 0],
            [-97.20732, 49.92101, 0],
            [-97.20732, 49.9218, 0],
            [-97.20943, 49.9218, 0],
          ],
        ],
      },
      properties: {
        name: 'N4',
        styleUrl: '#poly-6680B5-1000-255-nodesc',
        styleHash: '-1562606b',
        styleMapHash: {
          normal: '#poly-6680B5-1000-255-nodesc-normal',
          highlight: '#poly-6680B5-1000-255-nodesc-highlight',
        },
        stroke: '#6680b5',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#6680b5',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.21043, 49.92259, 0],
            [-97.21043, 49.92191, 0],
            [-97.20927, 49.92191, 0],
            [-97.20927, 49.92259, 0],
            [-97.21043, 49.92259, 0],
          ],
        ],
      },
      properties: {
        name: 'N5',
        styleUrl: '#poly-6680B5-1000-255-nodesc',
        styleHash: '-1562606b',
        styleMapHash: {
          normal: '#poly-6680B5-1000-255-nodesc-normal',
          highlight: '#poly-6680B5-1000-255-nodesc-highlight',
        },
        stroke: '#6680b5',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#6680b5',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.141035, 49.901007, 0],
            [-97.141241, 49.900742, 0],
            [-97.140858, 49.90062, 0],
            [-97.140652, 49.900888, 0],
            [-97.141035, 49.901007, 0],
          ],
        ],
      },
      properties: {
        name: 'EDC Parking 1',
        styleUrl: '#poly-00A3B4-1000-255-nodesc',
        styleHash: '64f725bc',
        styleMapHash: {
          normal: '#poly-00A3B4-1000-255-nodesc-normal',
          highlight: '#poly-00A3B4-1000-255-nodesc-highlight',
        },
        stroke: '#00a3b4',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#00a3b4',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.144449, 49.901082, 0],
            [-97.144672, 49.900778, 0],
            [-97.143891, 49.900521, 0],
            [-97.143659, 49.900826, 0],
            [-97.144449, 49.901082, 0],
          ],
        ],
      },
      properties: {
        name: 'EDC Parking 2',
        styleUrl: '#poly-00A3B4-1000-255-nodesc',
        styleHash: '64f725bc',
        styleMapHash: {
          normal: '#poly-00A3B4-1000-255-nodesc-normal',
          highlight: '#poly-00A3B4-1000-255-nodesc-highlight',
        },
        stroke: '#00a3b4',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#00a3b4',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.144257, 49.898797, 0],
            [-97.144511, 49.89847, 0],
            [-97.144186, 49.898366, 0],
            [-97.143934, 49.89869, 0],
            [-97.144257, 49.898797, 0],
          ],
        ],
      },
      properties: {
        name: 'EDC Parking 3',
        styleUrl: '#poly-00A3B4-1000-255-nodesc',
        styleHash: '64f725bc',
        styleMapHash: {
          normal: '#poly-00A3B4-1000-255-nodesc-normal',
          highlight: '#poly-00A3B4-1000-255-nodesc-highlight',
        },
        stroke: '#00a3b4',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#00a3b4',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.14114, 49.898814, 0],
            [-97.141253, 49.898683, 0],
            [-97.140966, 49.898588, 0],
            [-97.140856, 49.898726, 0],
            [-97.14114, 49.898814, 0],
          ],
        ],
      },
      properties: {
        name: 'EDC Parking 4',
        styleUrl: '#poly-00A3B4-1000-255-nodesc',
        styleHash: '64f725bc',
        styleMapHash: {
          normal: '#poly-00A3B4-1000-255-nodesc-normal',
          highlight: '#poly-00A3B4-1000-255-nodesc-highlight',
        },
        stroke: '#00a3b4',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#00a3b4',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.140124, 49.898457, 0],
            [-97.140129, 49.898148, 0],
            [-97.139869, 49.898145, 0],
            [-97.139871, 49.898293, 0],
            [-97.139429, 49.898296, 0],
            [-97.139465, 49.898452, 0],
            [-97.140124, 49.898457, 0],
          ],
        ],
      },
      properties: {
        name: 'EDC Parking 5',
        styleUrl: '#poly-00A3B4-1000-255-nodesc',
        styleHash: '64f725bc',
        styleMapHash: {
          normal: '#poly-00A3B4-1000-255-nodesc-normal',
          highlight: '#poly-00A3B4-1000-255-nodesc-highlight',
        },
        stroke: '#00a3b4',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#00a3b4',
        'fill-opacity': 1,
      },
    },
  ],
};

export default parkingLots;
